import { Button } from '@upmc/ims.component-library';
import { useHistory } from 'react-router-dom';

import StyleAuxiliary from '../../hoc/Auxiliary/StyleAuxiliary/StyleAuxiliary';
import WithLoadingHandler from '../../hoc/withLoadingHandler/withLoadingHandler';
import Card from '../../components/UI/MDC/Card/Card';
import { Headline4 } from '../../components/UI/MDC/Typography/Typography';
import Icon from '../../components/UI/MDC/Icon/Icon';
import { CSS_CLASSES } from './_constants';
import { basePropTypes } from './_types';

import classes from './Base.module.scss';

const Base = props => {
	let { helpLink, loading, title, isError, ...restProps } = props;
	const history = useHistory();

	return (
		<StyleAuxiliary classes={classes[CSS_CLASSES.ROOT_CONTAINER]}>
			<Card large {...restProps}>
				<StyleAuxiliary classes={classes[CSS_CLASSES.TITLE_CONTAINER]}>
					<Button sx={{ visibility: 'hidden' }}>Help</Button>
					<Headline4 className={classes[CSS_CLASSES.TITLE]}>
						{title}
					</Headline4>
					<Button
						variant='text'
						aria-label='Help'
						color='primary'
						sx={
							!(helpLink && String(helpLink).length > 1) && {
								visibility: 'hidden',
							}
						}
						href={helpLink}
						id='base__button--help'
						rel='noopener noreferrer'
						target='_blank'
						title='Help'
					>
						Help
					</Button>
				</StyleAuxiliary>
				{isError && (
					<Button
						sx={{ my: '0', mx: 'auto' }}
						aria-label='Refresh'
						onClick={() =>
							history.push(
								'/index.html?redirect=' +
									window.location.pathname
							)
						}
						rel='noopener noreferrer'
						target='_blank'
						title='Refresh'
						endIcon={<Icon icon='refresh' />}
						variant='outlined'
					>
						Refresh
					</Button>
				)}
				<WithLoadingHandler
					isLoading={loading}
					showChildren={!loading && !isError}
				>
					{restProps.children}
				</WithLoadingHandler>
			</Card>
		</StyleAuxiliary>
	);
};

Base.propTypes = basePropTypes;

export default Base;
